import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor() { }

  private paymentMethodSource = new Subject<boolean>();
  private paymentMethodIdSource = new Subject<string>();

  getPaymentMethodRequest$ = this.paymentMethodSource.asObservable();
  getPaymentMethodSuccess$ = this.paymentMethodIdSource.asObservable();

  generatePaymentMethod() {
    this.paymentMethodSource.next(true);
  }

  paymentMethodGenerated(paymentMethodId: string) {
    this.paymentMethodIdSource.next(paymentMethodId);
  }

}
